import { render, staticRenderFns } from "./sceneOptions.vue?vue&type=template&id=36c30940&"
import script from "./sceneOptions.vue?vue&type=script&lang=js&"
export * from "./sceneOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c30940')) {
      api.createRecord('36c30940', component.options)
    } else {
      api.reload('36c30940', component.options)
    }
    module.hot.accept("./sceneOptions.vue?vue&type=template&id=36c30940&", function () {
      api.rerender('36c30940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/sceneOptions.vue"
export default component.exports